import { FC } from "react";

import { DraggableWrapper, DroppableRideWrapper } from "@ryde/controls";
import { useRidesNavigation } from "@ryde/redux";
import {
  DragTypeEnum,
  DropTypeEnum,
  generateDragIdKanbanItem,
  generateDropIdKanbanItem,
  IKanbanItem,
} from "@ryde/shared";

import { KanbanItem } from "./rides.kanban.item";

export const RidesKanbanItemWrapper: FC<IKanbanItem> = ({
  rideDto: dto,
}): JSX.Element => {
  const { isRidesEditOrAddRoute } = useRidesNavigation();

  const draggableId = generateDragIdKanbanItem(dto.id);

  return (
    <DroppableRideWrapper
      id={generateDropIdKanbanItem(dto.id)}
      disabled={isRidesEditOrAddRoute}
      dropData={{
        accepts: [DragTypeEnum.KANBAN_PASSENGER, DragTypeEnum.KANBAN_RIDE],
        typeDrop: DropTypeEnum.KANBAN_RIDE_DROP,
        rideDrop: dto,
      }}
    >
      <DraggableWrapper
        id={draggableId}
        disabled={isRidesEditOrAddRoute}
        dragData={{ type: DragTypeEnum.KANBAN_RIDE, payload: { rideDto: dto } }}
        isListeners={false}
      >
        <KanbanItem rideDto={dto} />
      </DraggableWrapper>
    </DroppableRideWrapper>
  );
};
